export default "__VITE_ASSET__8bdfbe8d__"